import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography, IconButton } from '@material-ui/core';
import { Theaters, Close } from '@material-ui/icons';

export default function VideoDropzone({
  onChange,
  onDelete,
  onReject,
  acceptedFiles = ['video/*'],
  maxFileSize,
  dropzoneText,
}) {
  const [fileName, setFileName] = useState(null);

  const onDrop = useCallback((accepted) => {
    if (!accepted.length) return;
    setFileName(accepted[0].name);
    onChange(accepted);
  }, [onChange]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    onDropRejected: onReject,
    accept: acceptedFiles,
    maxSize: maxFileSize,
    multiple: false,
  });

  const handleRemove = (e) => {
    e.stopPropagation();
    setFileName(null);
    if (onDelete) {
      onDelete();
  }
};

  return (
  <Box
  {...getRootProps()}
  style={{
    border: '2px dashed #C0C0C0',
    borderRadius: 4,
    padding: 24,
    textAlign: 'center',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: 250,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'border-color 0.2s, background-color 0.2s',
    borderColor: isDragActive ? '#2DCE98' : '#C0C0C0',
    backgroundColor: isDragActive ? 'rgba(45,206,152,0.06)' : 'transparent',
  }}
>
    <input {...getInputProps()} />
    <Theaters style={{ fontSize: 56, opacity: 0.5, marginBottom: 12 }} />
      {fileName ? (
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
          <Typography variant="body2">{fileName}</Typography>
          <IconButton size="small" onClick={handleRemove}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      ) : (
        <Typography variant="body2">
          {isDragActive ? 'Solte o arquivo aqui...' : dropzoneText}
        </Typography>
      )}
    </Box>
  );
}